/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBioMatrixScanNext.vue?vue&type=template&id=4ec3afa3&scoped=true"
import script from "./popBioMatrixScanNext.vue?vue&type=script&lang=js"
export * from "./popBioMatrixScanNext.vue?vue&type=script&lang=js"
import style0 from "./popBioMatrixScanNext.vue?vue&type=style&index=0&id=4ec3afa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3afa3",
  null
  
)

export default component.exports